import Main from './top/_main';

const main = new Main();
